import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Chart  from 'react-apexcharts';

function ApexCharts ({chartData, className,height, width, type})  {
  // A chart that is given a percentage width is drawn at the width its container had when it was first drawn. Inside a popup that
  // is still opening (or a panel that is still laying out) that can be a few pixels, and the chart then stays tiny. So the
  // container is measured, the chart gets that width in pixels, and it is redrawn whenever the container changes size.
  const isPercent = typeof width === 'string' && width.trim().endsWith('%');
  const containerRef = useRef(null);
  const [measured, setMeasured] = useState(0);

  useEffect(() => {
    const element = containerRef.current;
    if (!isPercent || !element) return undefined;
    const share = parseFloat(width) / 100;
    let frame = null;
    const update = () => {
      frame = null;
      const next = Math.floor(element.clientWidth * share);
      setMeasured((previous) => (Math.abs(previous - next) >= 2 ? next : previous));
    };
    const schedule = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };
    update();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
    if (observer) observer.observe(element);
    window.addEventListener('resize', schedule);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', schedule);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [isPercent, width]);

  if (!isPercent) {
    return (
      <Chart
          options={chartData.options}
          series={chartData.series}
          type={type}
          height={height}
          width={width}
          className={className}
      />
    );
  }

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      {measured > 0 && (
        <Chart
            options={chartData.options}
            series={chartData.series}
            type={type}
            height={height}
            width={measured}
            className={className}
        />
      )}
    </div>
  );
}
ApexCharts.propTypes = {
    chartData: PropTypes.object,
    className: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type: PropTypes.string
};

export default ApexCharts
